'use es6';

import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EntityTypes, Networks } from 'AdsUI/lib/Constants';
import ReportingCampaignRecord from 'AdsUI/records/reporting/ReportingCampaignRecord';
import CampaignStatusToggleButtonContainer from 'AdsUI/containers/campaign-details/control-buttons/CampaignStatusToggleButtonContainer';
import AdWordsRemoveCampaign from 'AdsUI/containers/campaign-details/control-buttons/AdWordsRemoveCampaign';
import { isEntityDeleted } from 'AdsUI/lib/Utils';
import StopPropagationWrapper from 'AdsUI/components/StopPropagationWrapper';
import { NavMarker } from 'react-rhumb';
import CampaignEditButton from './control-buttons/CampaignEditButton';
import { hasAdsProScope, hasAdvancedAdWordsAccess } from 'AdsUI/selectors/AuthSelectors';

const NavMarkerControlButton = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "DEFAULT_CONTROL_BUTTON_LOADED"
});

const ControlButtonsOrder = [{
  ControlButton: CampaignStatusToggleButtonContainer,

  shouldRender() {
    return true;
  }

}, {
  ControlButton: AdWordsRemoveCampaign,

  shouldRender({
    showLegacyButtons,
    entity
  }) {
    return showLegacyButtons && entity.network === Networks.ADWORDS && !isEntityDeleted(entity.network, entity.status);
  }

}, {
  // This component should always render; therefore, it can be used as a check that the
  // control buttons container logic is working properly.
  ControlButton: NavMarkerControlButton,

  shouldRender({
    entity: {
      network
    }
  }) {
    return Object.keys(Networks).indexOf(network) !== -1;
  }

}, {
  ControlButton: CampaignEditButton,

  shouldRender({
    showCampaignManagement
  }) {
    return showCampaignManagement;
  }

}];

const CampaignDetailsHeaderControlButtons = props => {
  return /*#__PURE__*/_jsx(StopPropagationWrapper, {
    children: ControlButtonsOrder.filter(ControlButton => ControlButton.shouldRender(props)).map(({
      ControlButton
    }, index) => /*#__PURE__*/_createElement(ControlButton, Object.assign({}, props, {
      key: index,
      entityType: EntityTypes.CAMPAIGN
    })))
  });
};

CampaignDetailsHeaderControlButtons.propTypes = {
  entity: PropTypes.instanceOf(ReportingCampaignRecord).isRequired
};
export default connect(state => ({
  showLegacyButtons: hasAdsProScope(state) && hasAdvancedAdWordsAccess(state)
}))(CampaignDetailsHeaderControlButtons);